<template>
  <div class="Quils">
    <!-- <div class="title">{{ title }}</div> -->
    <div class="title" v-if="moduleIsShow == 'true'" @click="addCalss()">
      <span>{{ title }}</span>
      <i class="iconfont icon-right_medium"></i>
    </div>
    <div class="title" v-else @click="addCalss()">
      <p>
        {{ title }}
        <span
          v-if="moduleAnnotation != ''"
          class="ts-info iconfont icon-zhu"
          @click.stop="isNotes()"
        >
        </span>
      </p>

      <i
        class="iconfont"
        :class="isBoolean ? 'icon-up_medium' : 'icon-down_medium'"
      ></i>
    </div>
    <div class="show-box" v-show="isBoolean"></div>
    <div class="main" v-show="isBoolean" v-html="htmlContent"></div>
  </div>
</template>
<script>
import { Quils } from "@/api/reportQuery";

export default {
  props: {
    moduleAnnotation: {
      type: String,
    },
    title: {
      type: String,
    },
    moduleIsShow: {
      type: String,
    },
    templateIsShow: {
      type: String,
    },
    templateId: {
      type: String,
    },
  },
  data() {
    return {
      isBoolean: this.templateIsShow == 'false'?false:true,
      htmlContent: "",
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    addCalss() {
      this.isBoolean = !this.isBoolean;
    },
    async getData() {
      try {
        let { data } = await Quils({
          moduleId: this.templateId,
        });
        this.htmlContent = data;
      } catch (error) {}
    },
  },
};
</script>
<style lang="less" scoped>
.show-box {
  height: 20px;
  background: linear-gradient(
    360deg,
    rgba(58, 74, 134, 0) 0%,
    rgba(58, 74, 134, 0.06) 100%
  );
  margin-bottom: 10px;
}
.Quils {
  margin-bottom: 20px;
  background: @background_color;
  border-radius: 10px;
  /deep/.main {
    padding: 0 20px 20px;
    color: #5f697d !important;
    font-size: 15PX;
    font-weight: 400;
    line-height: 30px;
    word-break: break-all;
    text-align: justify;
    text-justify: newspaper;
  }
  .title {
    font-size: 18PX;
    font-weight: 500;
    color: #2f354d;
    // line-height: 70px;
    padding: 24px 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .ts-info {
      color: #a4a9bf;
      // position: absolute;
    }
    i {
      min-width: 16px;
    }
  }
}
</style>
